

























import { mapState } from "vuex";
import IconBase from "@/common/components/atoms/IconBase.vue";
import IconSearchEmpty from "@/common/components/icons/IconSearchEmpty.vue";
import IconBell from "@/common/components/icons/IconBell.vue";
import { Vue, Component, Prop } from "vue-property-decorator";
import globals from "@/general/store/modules/globals";
import commons from "@/common/store/modules/commons";
// import commons from "@/common/store/modules/commons";
// import store from "@/general/store";
@Component({
  components: {
    IconBase,
    IconSearchEmpty,
    IconBell
  },
  computed: {
    ...mapState({
      colorCode: () => commons.colorCode
    })
  }
})
export default class TheL01EmptyPanel extends Vue {
  @Prop({ type: String, required: true }) searchKeyword!: string;

  isSp = globals.isSpScreenWidth;

  get iconSize() {
    // const isSp = store.state.isSpScreenWidth;
    const isSp = globals.isSpScreenWidth;
    if (isSp) {
      return {
        width: 103,
        height: 105
      };
    } else {
      return {
        width: 159,
        height: 162
      };
    }
  }
}
